import {StateMatrix} from "./StateMatrix";
import {
    ClientTorpedoPart,
    ClientXNudge,
    ClientXWays,
    DasUBootData,
    DasUBootGameData,
    DasUBootInitData,
    DasUBootTorpedoData,
    DasUBootXNudgeData,
    DasUBootXWayData,
    isDasUBootGameData
} from "../server/DasUBootData";
import {DasUBootSymbolStates} from "../reels/DasUBootSymbol";
import {ClientGameData, WinData, WinLineData} from "../server/DasUBootModel";
import {DasUBootStatics} from "./DasUBootStatics";
import {DasUBoot} from "../DasUBoot";
import {DasUBootGameMode} from "../server/DasUBootGameMode";

/**
 * Created by jonas on 2021-06-07.
 */

export class ModelUtils {

    //Scatters

    public static calculateScatterIndexAtReel(visibleReelsMatrix:StateMatrix<string>, data?:DasUBootInitData | DasUBootGameData):number[] {
        const result:number[] = [0, 0, 0, 0, 0, 0];
        let count = 0;

        if (data && isDasUBootGameData(data)) {
            for (let i:number = 0; i < data.scatterPositions.length; i++) {
                if (data.scatterPositions[i] >= 0) {
                    count++;
                    result[i] = count;
                }

            }
        } else {
            for (let pos of visibleReelsMatrix.getAllCoordinateForValue("S")) {
                count++;
                result[pos.column] = count;
            }
        }
        return result;
    }

    public static calculateScatterCountCollectedAtReel(visibleReelsMatrix:StateMatrix<string>, data?:DasUBootInitData | DasUBootGameData):number[] {
        const result:number[] = [0, 0, 0, 0, 0, 0];
        let count = 0;

        if (data && isDasUBootGameData(data)) {
            for (let i:number = 0; i < data.scatterPositions.length; i++) {
                if (data.scatterPositions[i] >= 0) {
                    count++;
                }
                result[i] = count;

            }
        } else {
            for (let pos of visibleReelsMatrix.getAllCoordinateForValue("S")) {
                count++;
                result[pos.column] = count;
            }
        }
        return result;
    }


    //Torpedo

    public static getTorpedoPartSize(i:number, data?:DasUBootTorpedoData):number {
        if (data == undefined){
            return 0;
        }

        switch (i) {
            case 0:
                return data.sizeTail;
            case 1:
                return data.multiplierReel3;
            case 2:
                return data.multiplierReel4;
            case 3:
                return data.sizeNose;
        }
        return 0;
    }

    public static getFiredTorpedoData(i:number, data:DasUBootTorpedoData):{symbol:string} {
        const result = {
            symbol:""
        }

        switch (i) {
            case 0:
                result.symbol = data.symbolTail
                break;
            case 1:
                result.symbol = data.symbolMid
                break;
            case 2:
                result.symbol = data.symbolMid
                break;
            case 3:
                result.symbol = data.symbolNose
                break;
        }

        return result;
    }

    static getTorpedoSizes(data?:DasUBootTorpedoData):number[] {
        return [
            ModelUtils.getTorpedoPartSize(0, data),
            ModelUtils.getTorpedoPartSize(1, data),
            ModelUtils.getTorpedoPartSize(2, data),
            ModelUtils.getTorpedoPartSize(3, data),
        ]
    }

    public static findTorpedoParts3(visibleReelsMatrix:StateMatrix<string>, mode:DasUBootGameMode, oldTorpedoData?:DasUBootTorpedoData, data?:DasUBootTorpedoData):[ClientTorpedoPart?, ClientTorpedoPart?, ClientTorpedoPart?, ClientTorpedoPart?] {
        const result:[ClientTorpedoPart?, ClientTorpedoPart?, ClientTorpedoPart?, ClientTorpedoPart?] = [];

        if (data) {

            let oldSizes:number[] = ModelUtils.getTorpedoSizes(oldTorpedoData);
            if (oldTorpedoData?.isComplete){
                oldSizes = [0,0,0,0];
            }

            for (let i:number = 0; i < 4; i++) {
                if (!data.torpedoParts[i]) {
                    //No active part
                    result.push(undefined);
                    continue;
                }

                const newSize = ModelUtils.getTorpedoPartSize(i, data);

                const isNewPart = oldSizes[i] == 0;
                let landingSize = 1;
                if (isNewPart){
                    landingSize = 2;
                }

                const torpedoPart:ClientTorpedoPart = {
                    reel:i + 1,
                    size:newSize,
                    landingSize:landingSize,
                    addedThisSpin:undefined,
                    firedThisSpin:undefined,
                }

                if (data.isComplete) {
                    torpedoPart.firedThisSpin = ModelUtils.getFiredTorpedoData(i, data)
                }


                const tSymbols = visibleReelsMatrix.getCoordinatedForValueInColumn(i + 1, "T");
                if (tSymbols.length > 0 && mode != DasUBootGameMode.AVALANCHE) {
                    let fallSize = newSize - oldSizes[i];

                    torpedoPart.addedThisSpin = {
                        position:tSymbols[0].row,
                        fallSize:fallSize
                    }
                } else if (tSymbols.length > 1) {
                    DasUBoot.apiPlugin.warn("To many T symbols landed on one reel");
                }

                result.push(torpedoPart);

            }
        }

        return result;
    }


    //Matrix utils

    public static trimMatrixEndsToSize(matrix:any[][], gameAreaSize:number[]) {
        for (let i:number = 0; i < DasUBootStatics.defaultGameAreaSize.length; i++) {
            matrix[i] = matrix[i].slice(0, gameAreaSize[i]);
        }
        return matrix;
    }

    public static trimMatrixToGameAreaSizeWithPadding(matrix:any[][], gameAreaSize:number[]) {
        for (let i:number = 0; i < gameAreaSize.length; i++) {
            const start = gameAreaSize[i] == 8 ? 1 : 3;
            const end = gameAreaSize[i] + start;
            matrix[i] = matrix[i].slice(start, end);
        }
        return matrix;
    }

    public static trimColumnsToMatchMatrix(matrix:any[][], sizeMatrix:any[][]):any[][] {
        for (let i:number = 0; i < sizeMatrix.length; i++) {
            matrix[i] = matrix[i].slice(0, sizeMatrix[i].length);
        }

        return matrix;
    }


    //xWays
    public static createClientXWayData(data?:DasUBootXWayData):ClientXWays[] {
        const result:ClientXWays[] = [];
        if (data) {
            for (let i:number = 0; i < data.positions.length; i++) {
                const pos = data.positions[i];
                if (pos >= 0) {
                    result.push({
                        reel:i == 0 ? 1 : 4,
                        position:pos,
                        symbol:data.symbol,
                        size:data.size,
                    });
                }

            }
        }

        return result;
    }


    //xNudge
    public static findStackedWilds(data:ClientGameData, replace:boolean = false) {
        for (let xNudge of data.xNudge) {
            if (replace) {
                data.reels[xNudge.reel].splice(xNudge.w4StartPos, 4, "W", "W", "W", "W4");
            } else {
                data.reels[xNudge.reel].splice(xNudge.w4StartPos, 4, "W", "W", "W", "W");
            }

        }
        return data.reels;
    }

    public static createClientXNudgeData(winMatrix:StateMatrix<DasUBootSymbolStates>, data?:DasUBootXNudgeData):ClientXNudge[] {
        //Make client data
        const result = [];
        if (data) {
            for (let i:number = 0; i < data.doReelNudge.length; i++) {

                if (data.doReelNudge[i]) {
                    const reel = i + 2;
                    const startPos = data.up[i] ? data.rowHits[i] + 3 : data.rowHits[i] - 1;
                    const endPos = 3;

                    result.push({
                        reel:i + 2,
                        steps:data.multipliers[i] - 1,
                        up:data.up[i],
                        isInWin:winMatrix.matrix[reel][endPos] == DasUBootSymbolStates.WIN,
                        w4StartPos:startPos,
                        w4EndPos:endPos
                    });
                }
            }
        }

        return result;
    }


    //Win ways

    public static calculateTotalWays(data:DasUBootGameData):number {
        let total = 0;
        for (let betway of data.betWayWins) {
            total += betway.numberOfCombinations;
        }
        return total;
    }

    public static calculatePossibleWinWays(xWays:ClientXWays[], isFreespin:boolean):number[] {
        const result = [0, 0, 0, 0, 0, 0];
        let baseSymbolSizes = DasUBootStatics.defaultGameAreaSize.concat();

        if (isFreespin){
            baseSymbolSizes = DasUBootStatics.freespinGameAreaSize.concat();
        }


        const totalSymbolSizes = baseSymbolSizes.concat();

        for (let xWay of xWays) {
            totalSymbolSizes[xWay.reel] += xWay.size - 1;
        }
        for (let i:number = 0; i < result.length; i++) {
            let array = totalSymbolSizes.slice(0, i + 1);
            array = array.concat(baseSymbolSizes.slice(i + 1));
            result[i] = array.reduce((previousValue:number, currentValue:number) => previousValue * currentValue);

        }

        return result;
    }

    public static calculateTotalPossibleWinWays(clientData:ClientGameData, data:DasUBootData) {

        const reelSizes = data.gameAreaSize.concat();

        for (let xWay of clientData.xWays) {
            reelSizes[xWay.reel] += xWay.size - 1;
        }


        if (data.torpedo && data.torpedo.isComplete){
            reelSizes[1] += clientData.torpedoSizes[0];
            reelSizes[2] += clientData.torpedoSizes[1];
            reelSizes[3] += clientData.torpedoSizes[2];
            reelSizes[4] += clientData.torpedoSizes[3];
        }

        const result = reelSizes.reduce((previousValue:number, currentValue:number) => previousValue * currentValue);

        return result;
    }


    //Win data

    public static createWinData(data:DasUBootData, visibleReelsMatrix:StateMatrix<string>):WinData {
        const winLines:WinLineData[] = [];
        const winMatrix = new StateMatrix<DasUBootSymbolStates>();
        winMatrix.initWithValue(6, 10, DasUBootSymbolStates.NO_WIN);

        if (isDasUBootGameData(data)) {
            for (let win of data.betWayWins) {
                const lineMatrix:StateMatrix<boolean> = new StateMatrix();
                lineMatrix.initWithValue(6, 10, false);
                const lineData:WinLineData = {
                    betWayWin:win,
                    winCoordinates:[],
                    lineMatrix:lineMatrix
                }

                for (let i:number = 0; i < win.reelWinPositions.length; i++) {
                    for (let j:number = 0; j < win.reelWinPositions[i].length; j++) {
                        if (win.reelWinPositions[i][j]) {
                            winMatrix.matrix[i][j] = DasUBootSymbolStates.WIN;
                            lineMatrix.matrix[i][j] = true;
                            lineData.winCoordinates.push({column:i, row:j})
                        }
                    }
                }

                //Remove positions that are inactive due to the asymmetry of the reels.
                /*          for (let i:number = 0; i < DasUBootStatics.defaultGameAreaSize.length; i++) {
                              lineMatrix.matrix[i] = lineMatrix.matrix[i].slice(0, data.gameAreaSize[i]);
                          }*/
                lineMatrix.matrix = ModelUtils.trimMatrixEndsToSize(lineMatrix.matrix, data.gameAreaSize);

                winLines.push(lineData);
            }
        }

        //Remove positions of "special" symbols
        const positions = visibleReelsMatrix.getAllCoordinateForValue("B");
        for (let pos of positions) {
            winMatrix.matrix[pos.column][pos.row] = DasUBootSymbolStates.NORMAL;
        }

        //Remove positions that are inactive due to the asymmetry of the reels.
        /*
                for (let i:number = 0; i < DasUBootStatics.defaultGameAreaSize.length; i++) {
                    winMatrix.matrix[i] = winMatrix.matrix[i].slice(0, data.gameAreaSize[i]);
                }
        */

        winMatrix.matrix = ModelUtils.trimMatrixEndsToSize(winMatrix.matrix, data.gameAreaSize);

        return {
            lines:winLines,
            matrix:winMatrix
        }

    }

    public static searchForSymbol(searchMatrix:StateMatrix<string>, matrix:boolean[][], searchSymbol:string, lineMakers:string[]) {
        const searchSymbols = lineMakers.concat([searchSymbol]);
        for (let i:number = 1; i < searchMatrix.matrix.length; i++) {
            let foundInReel = false;

            for (let j:number = 0; j < searchMatrix.matrix[i].length; j++) {
                const value = searchMatrix.matrix[i][j];
                const found = searchSymbols.indexOf(value) >= 0;

                if (found) {
                    matrix[i][j] = true;
                    foundInReel = true;
                }
            }

            if (!foundInReel) {
                break;
            } else {
                if (i == 1) {
                    const firstReelPositions = searchMatrix.getCoordinatedForValueInColumn(0, searchSymbol);
                    for (let pos of firstReelPositions) {
                        matrix[pos.column][pos.row] = true;
                    }
                }
            }
        }

        return matrix;
    }


    //xBomb

    public static processCollapse(evaluatedArea:string[][], nextMode:DasUBootGameMode):StateMatrix<number> {
        const stateMatrix = new StateMatrix<number>();
        stateMatrix.initWithValue(6, 4, 0);
        if (nextMode == DasUBootGameMode.AVALANCHE) {

            for (let i:number = 0; i < evaluatedArea.length; i++) {
                let dropCountOnReel = 0;
                for (let j:number = evaluatedArea[i].length - 1; j >= 0; j--) {

                    let value = evaluatedArea[i][j];
                    let state = 0;
                    if (value == "-") {
                        state = -1;
                        dropCountOnReel += 1;
                    } else {
                        state = dropCountOnReel;
                    }

                    stateMatrix.matrix[i][j] = state;
                }
            }
        }

        return stateMatrix;
    }


}